import Chip from "@mui/material/Chip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { MaintenanceDisplayData } from "@/models/MaintenanceDisplayData";

// simple contrast calc for legible text
function getTextColor(bg: string): "#000" | "#fff" {
  const hex = bg.replace("#", "");
  if (hex.length !== 6) return "#000";
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  // luminance
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return lum > 160 ? "#000" : "#fff";
}

export const MaintenanceStatusCodeCell = (
  params: GridRenderCellParams<MaintenanceDisplayData, number>,
) => {
  const { colorIntervals } = useDataGridSettings();
  const field = "statusCode";
  const value = params.value;

  let chipBg: string | undefined;

  const intervals = colorIntervals[field] ?? [];
  for (const it of intervals) {
    const min = it.min as any;
    const max = it.max as any;

    const nVal = Number(value);
    const inRange =
      min === max
        ? String(min) === String(value)
        : !isNaN(Number(min)) && !isNaN(Number(max)) && Number(min) <= nVal && nVal <= Number(max);

    if (inRange) {
      chipBg = it.color;
      break;
    }
  }

  if (!chipBg) {
    return <Chip label={params.formattedValue} color="default" size="small" />;
  }

  const fg = getTextColor(chipBg);

  return (
    <Chip
      label={params.formattedValue}
      size="small"
      sx={{
        bgcolor: chipBg,
        color: fg,
        "& .MuiChip-label": { px: 1.25 },
      }}
    />
  );
};

export default MaintenanceStatusCodeCell;
